import { Controller } from 'stimulus';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

/**
 *  Initialize scroll animation for the intro section
 *
 * @class IntroAnimationController
 * @extends {Controller}
 */
class IntroAnimationController extends Controller {
  connect() {
    this.animation();
  }

  animation() {
    const timeline = gsap.timeline();

    timeline.to(this.titleTarget, { duration: 2, xPercent: -250, opacity: 0 });
    timeline.to(this.logoTarget, { opacity: 0 }, 0.5);
    timeline.to(this.secondTitleTarget, { opacity: 1 }, 0.5);
    timeline.to(this.textTarget, { opacity: 1 }, 0.6);
    timeline.to(this.imageTarget, { xPercent: -120 }, 0.8);
    timeline.to(this.textTarget, { opacity: 0 });

    timeline.delay(0.5).timeScale(0.35).play();
  }

  // eslint-disable-next-line class-methods-use-this
  onButtonClick() {
    this.element.classList.add('translate');
  }
}

IntroAnimationController.targets = [
  'image',
  'title',
  'secondTitle',
  'text',
  'content',
  'container',
  'logo',
];

export default IntroAnimationController;
